import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Label,
} from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import { MDBDataTable } from "mdbreact";
import { Link, useLocation, useParams } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { Button } from "react-bootstrap";
import moment from "moment";

const ViewSangathanMemberList = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [sangathanName, setSangathanName] = useState("");
  const [sangathanUserList, setSangathanUserList] = useState([]);
  const [sangathanId, setSangathanId] = useState("");
  const { parentId, type } = useParams();
  const location = useLocation();
  const [sameSangathan, setSameSangathan] = useState(true);
  const hierarchy = location.state?.hierarchy || [];
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [defaultFilter, setDefaultFilter] = useState(false);
  const startRef = useRef(null);
  const endRef = useRef(null);
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Sangathan Member List", link: "#" },
  ];
  useEffect(() => {
    onGetSangathanUserList(type);
    setDefaultFilter(!!(startDate && endDate));
    props.setBreadcrumbItems("Sangathan Member List", breadcrumbItems);
  }, []);
  const formatLocalDate = (date) => {
    if (!date) return false;
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${y}-${m.toString().padStart(2, "0")}-${d.toString().padStart(2, "0")}`;
  };
  function exportToExcel(data) {
    var fileName = "SangathanMemberList";
    const flatData = (data || []).map((item) => {
      const user = item.userId || {};
      return {
        FullName: `${user.firstName || ""} ${user.lastName || ""}`,
        Gender: user.gender,
        VUF_ID: user.vufId || "",
        District: user.district || "",
        City: user.city || "",
        Mobile: user.mobileNo || "",
        RoleSangathan: item.role || "",
      };
    });
    const worksheet = XLSX.utils.json_to_sheet(flatData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }
  const handleReset = () => {
    if (startRef.current && startRef.current.flatpickr) {
      startRef.current.flatpickr.clear();
    }
    setStartDate(null);
    if (endRef.current && endRef.current.flatpickr) {
      endRef.current.flatpickr.clear();
    }
    setStartDate(null);
    setEndDate(null);
    // setDefaultFilter(false);
    onGetSangathanUserList();
  };
  function onGetSangathanUserList(type) {
    setLoading(true);
    const start = formatLocalDate(startDate);
    const end = formatLocalDate(endDate);
    let urlPath;
    if (type === "sangathan" || (start && end)) {
      if (start && end) {
        urlPath = `/sangathan/get-sangathan-wise-member-list/${parentId}?startDate=${start}&endDate=${end}`;
      } else {
        urlPath = `/sangathan/get-sangathan-wise-member-list/${parentId}`;
      }
    } else {
      if (start && end) {
        urlPath = `/sangathan/get-member-list/${parentId}/all?startDate=${start}&endDate=${end}`;
      } else {
        urlPath = `/sangathan/get-member-list/${parentId}/all`;
      }
    }

    fetch(url.beta_url + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          setSangathanUserList(responseData.result);
          if (responseData.result && responseData.result.length > 0) {
            setSangathanName(responseData.result[0].sangathanId.name);
          }
        } else {
          // console.error("API Error:", responseData.error || "Unknown error");
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }
  const formatVUFID = (vufId) => {
    if (!vufId) return "";

    const clean = vufId.replace(/[^a-zA-Z0-9]/g, ""); // remove old dashes
    return clean.replace(/(.{4})(.{4})(.{4})/, "$1-$2-$3");
  };
  const formattedList = sangathanUserList.map((data) => ({
    ...data,
    fullName: `${data.userId.firstName} ${data.userId.lastName}`,
    mobileNo: data.userId.mobileNo || "---",
    VUFID: formatVUFID(data.userId.vufId),
    district: data.userId.district || "---",
    city: data.userId.city || "---",
    role: data.role || "---",
    gender: data.userId.gender || "---",
    joinDate: moment(data.createdAt).format("DD-MMM-YYYY"),
  }));
  const tableData = {
    columns: [
      {
        label: "Name",
        field: "fullName",
        width: 23,
      },
      {
        label: "Gender",
        field: "gender",
        width: 23,
      },
      {
        label: "Mobile No.",
        width: 13,
        field: "mobileNo",
      },
      {
        label: "District",
        width: 13,
        field: "district",
      },
      {
        label: "Taluko / City",
        width: 13,
        field: "city",
      },
      {
        label: "Joining Date",
        width: 13,
        field: "joinDate",
      },
      {
        label: "VUF Id",
        width: 13,
        field: "VUFID",
      },
      {
        label: "Role",
        width: 13,
        field: "role",
      },
    ],
    rows: formattedList,
  };
  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="12">
                    <CardTitle className="h4 mb-0">
                      Sangathan Member List of {sangathanName}
                    </CardTitle>
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/sangathan-member-list">Home</Link>
                        </li>
                        {hierarchy.map((item, i) => {
                          const isLast = i === hierarchy.length - 1;
                          return (
                            <li
                              key={item.id}
                              className={`breadcrumb-item ${isLast ? "active" : ""}`}
                              aria-current={isLast ? "page" : undefined}
                            >
                              {isLast ? (
                                item.name
                              ) : (
                                <Link
                                  to={`/parent-sangathans-list/${item.id}`}
                                  state={{
                                    hierarchy: hierarchy.slice(0, i + 1),
                                  }}
                                >
                                  {item.name}
                                </Link>
                              )}
                            </li>
                          );
                        })}
                      </ol>
                    </nav>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div className="row">
                  <div className="col-sm-2">
                    <div className="form-group">
                      <Label>Start Date</Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Select start date"
                        value={startDate}
                        onChange={(dates) => {
                          setStartDate(dates[0]);
                          // Optional: if endDate is before new startDate, reset it
                          if (endDate && dates[0] > endDate) {
                            setEndDate(null);
                          }
                        }}
                        options={{
                          mode: "single",
                          dateFormat: "d-m-Y",
                          maxDate: endDate || null, // endDate limits startDate
                        }}
                        ref={startRef}
                      />
                    </div>
                  </div>
                  <div className="col-sm-2">
                    <div className="form-group">
                      <Label>End Date</Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Select end date"
                        value={endDate}
                        onChange={(dates) => setEndDate(dates[0])}
                        options={{
                          mode: "single",
                          dateFormat: "d-m-Y",
                          minDate: startDate || null, // startDate limits endDate
                        }}
                        ref={endRef}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4 mt-4">
                    <button
                      type="button"
                      onClick={(e) =>
                        onGetSangathanUserList(null, null, startDate, endDate)
                      }
                      className="btn btn-outline-info me-2 mt-1"
                      style={{
                        outline: "none",
                        boxShadow: "none",
                        transform: "none",
                      }}
                    >
                      <span className="mdi mdi-magnify p-1"></span>
                      Search
                    </button>
                    {sangathanUserList.length > 0 && (
                      <button
                        className="btn btn-outline-success me-2 mt-1"
                        onClick={(event) => exportToExcel(sangathanUserList)}
                      >
                        <span className="mdi mdi-download p-1"></span>
                        Export Data
                      </button>
                    )}
                    <button
                      type="button"
                      className="btn btn-outline-secondary mt-1"
                      onClick={() => {
                        setDefaultFilter(false);
                        handleReset();
                      }}
                      style={{
                        outline: "none",
                        boxShadow: "none",
                        transform: "none",
                      }}
                    >
                      <span className="mdi mdi-lock-reset p-1"></span>
                      Reset
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div className="d-flex justify-content-end"></div>
                  <MDBDataTable
                    responsive
                    striped
                    entries={20}
                    bordered
                    data={tableData}
                    noBottomColumns={true}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(ViewSangathanMemberList);
